import Link from './link'
import Reports from './reports'

const modules = {
    Link,
    Reports
}

const state = {}

const mutations = {}
const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    modules
}
